module.exports = function() {
  return new Worker(__webpack_public_path__ + "1c885e5c19e959f9cef1.worker.js");
};